import { render } from "./SwitchToggle.vue?vue&type=template&id=7bca5723&scoped=true"
import script from "./SwitchToggle.vue?vue&type=script&lang=js"
export * from "./SwitchToggle.vue?vue&type=script&lang=js"

import "./SwitchToggle.vue?vue&type=style&index=0&id=7bca5723&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bca5723"]])

export default __exports__